<template>
    <b-container id="footer">
        <div class="inova-infos">Powered by
            <b-link href="https://www.inpart.io/" target="_blank" class="ml-2">
                <b-img class="inova-logo" :src="`${publicPath}assets/images/inpart-logo.png`"></b-img>
            </b-link>
        </div>
    </b-container>
</template>

<script>
    export default {
        name: "Footer",
        data () {
            return {
                publicPath: process.env.BASE_URL
            }
        }
    }
</script>

<style scoped>
    .inova-infos {
        padding-bottom: 20px;
        padding-top: 20px;
        display: flex;
        align-items: flex-end;
        font-size: 10px;
        text-transform: uppercase;
    }

    .inova-logo {
        max-height: 25px;
    }
</style>